export const restaurants = [
  {
    type: "restaurant",
    info: {
      resId: 18372686,
      name: "FreshMenu",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/4/17953934/8cd45d2b48642289a2da0983ad3e6857_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/4/17953934/8cd45d2b48642289a2da0983ad3e6857_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "25.5K",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.9",
            reviewCount: "25.5K",
            reviewTextSmall: "25.5K Reviews",
            subtext: "25.5K Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.9",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Kalkaji, New Delhi",
        address:
          "Floor 3, Ramji Lal, Complex Central Market, DDA Flats, Kalkaji, New Delhi",
        localityUrl: "ncr/kalkaji-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/continental/",
          name: "Continental"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/health-food/",
          name: "Healthy Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/mexican/",
          name: "Mexican"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "30 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/freshmenu-kalkaji-new-delhi/order"
      }
    },
    gold: [],
    bulkOffers: [
      {
        text: "Everything @ ₹139 only",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "10250+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
    // takeaway: [],
    // cardAction: {
    //   text: "",
    //   clickUrl: "/ncr/freshmenu-kalkaji-new-delhi/order",
    //   clickActionDeeplink: ""
    // },
    // distance: "3.1 km",
    // isPromoted: false,
    // promotedText: "",
    // trackingData: [
    //   {
    //     table_name: "zsearch_events_log",
    //     payload:
    //       '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18372686","element_type":"listing","rank":1}',
    //     event_names: {
    //       tap: '{"action":"tap"}',
    //       impression: '{"action":"impression"}'
    //     }
    //   }
    // ],
    // allCTA: [],
    // promoOffer: "",
    // checkBulkOffers: true,

    // isDisabled: false,
  },
  {
    type: "restaurant",
    info: {
      resId: 3639,
      name: "Sona Sweets Sri Udipi Restaurant",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/9/3639/1ea644e78c7a32f1cee8f79729e00128_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/9/3639/1ea644e78c7a32f1cee8f79729e00128_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.3",
        rating_text: "4.3",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "2,777",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "4.1",
            reviewCount: "472",
            reviewTextSmall: "472 Reviews",
            subtext: "472 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "4.1",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.4",
            reviewCount: "2,305",
            reviewTextSmall: "2,305 Reviews",
            subtext: "2,305 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.4",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Nehru Place, New Delhi",
        address: "G-1-27, Saraswati House, Nehru Place, New Delhi",
        localityUrl: "ncr/nehru-place-delhi-restaurants"
      },
      timing: {
        text: "Closes in 1 hour 54 minutes",
        color: "#e5521f"
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/south-indian/",
          name: "South Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/street-food/",
          name: "Street Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/mithai/",
          name: "Mithai"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "25 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl:
          "/ncr/sona-sweets-sri-udipi-restaurant-nehru-place-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl:
        "/ncr/sona-sweets-sri-udipi-restaurant-nehru-place-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.1 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"3639","element_type":"listing","rank":2}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "2250+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 20307735,
      name: "Bikanervala",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/1/491/aa50c08ea5ade50a6d1c2d7aca242a1c_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/1/491/aa50c08ea5ade50a6d1c2d7aca242a1c_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.8",
        rating_text: "3.8",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "282",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.7",
            reviewCount: "2",
            reviewTextSmall: "2 Reviews",
            subtext: "2 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.7",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.9",
            reviewCount: "280",
            reviewTextSmall: "280 Reviews",
            subtext: "280 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.9",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹450 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "East of Kailash, New Delhi",
        address: "Shop-1, Community Centre, Saket, East of Kailash, New Delhi",
        localityUrl: "ncr/east-of-kailash-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/mithai/",
          name: "Mithai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/south-indian/",
          name: "South Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/street-food/",
          name: "Street Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "21 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/bikanervala-east-of-kailash-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/bikanervala-east-of-kailash-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "457 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20307735","element_type":"listing","rank":3}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "3750+ orders placed from here recently"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 19313073,
      name: "Subway",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/7/147/c249b8f80da4d40d2d5771ae201edc32_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/7/147/c249b8f80da4d40d2d5771ae201edc32_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.3",
        rating_text: "3.3",
        rating_subtitle: "Average",
        rating_color: "CDD614",
        votes: "5,579",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.1",
            reviewCount: "103",
            reviewTextSmall: "103 Reviews",
            subtext: "103 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.1",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.5",
            reviewCount: "5,476",
            reviewTextSmall: "5,476 Reviews",
            subtext: "5,476 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.5",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "500"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Amar Colony, New Delhi",
        address: "C-10, Ground Floor, Amar Colony, New Delhi",
        localityUrl: "ncr/amar-colony-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTQzXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/health-food/",
          name: "Healthy Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzA0XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/sandwich/",
          name: "Sandwich"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyNFwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/wraps/",
          name: "Wraps"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/salad/",
          name: "Salad"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "25 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/subway-amar-colony-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/subway-amar-colony-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "799 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19313073","element_type":"listing","rank":4}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "30% OFF",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "3725+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/695598f38d29d0e5d3f8ffe57cfdb94c1613145422.png",
          aspect_ratio: 2.0625
        },
        text: "Restaurant partner follows WHO protocol"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 18692610,
      name: "Hira Sweets",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/2008/32edfc4b9cee788d3a0921f0f5ea0fa9_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/2008/32edfc4b9cee788d3a0921f0f5ea0fa9_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "9,806",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.6",
            reviewCount: "318",
            reviewTextSmall: "318 Reviews",
            subtext: "318 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.6",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.1",
            reviewCount: "9,488",
            reviewTextSmall: "9,488 Reviews",
            subtext: "9,488 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.1",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹500 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Lajpat Nagar 2, New Delhi",
        address: "J-2/B, Central Market, Lajpat Nagar 2, New Delhi",
        localityUrl: "ncr/lajpat-nagar-2-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/mithai/",
          name: "Mithai"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/street-food/",
          name: "Street Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/chinese/",
          name: "Chinese"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/pizza/",
          name: "Pizza"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/south-indian/",
          name: "South Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjMzXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/ice-cream/",
          name: "Ice Cream"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "27 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/hira-sweets-lajpat-nagar-2-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/hira-sweets-lajpat-nagar-2-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.4 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18692610","element_type":"listing","rank":5}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "4325+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 18715925,
      name: "Burger Singh - Big Punjabi Burgers",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/1/310301/0bb4ccbc6a9fb81b05c4870715419519_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/1/310301/0bb4ccbc6a9fb81b05c4870715419519_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.2",
        rating_text: "4.2",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "19.6K",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.2",
            reviewCount: "19.6K",
            reviewTextSmall: "19.6K Reviews",
            subtext: "19.6K Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.2",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹300 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Kalkaji, New Delhi",
        address: "B-91, 1st Floor, Kalkaji Main Road, Kalkaji, New Delhi",
        localityUrl: "ncr/kalkaji-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/burger/",
          name: "Burger"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/momos/",
          name: "Momos"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "27 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl:
          "/ncr/burger-singh-big-punjabi-burgers-kalkaji-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/burger-singh-big-punjabi-burgers-kalkaji-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18715925","element_type":"listing","rank":6}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "9700+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 20377540,
      name: "Bakingo",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/0/18416840/297e6c82fbf1b14832189765dd0bdcc5_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/0/18416840/297e6c82fbf1b14832189765dd0bdcc5_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.2",
        rating_text: "4.2",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "864",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.2",
            reviewCount: "864",
            reviewTextSmall: "864 Reviews",
            subtext: "864 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.2",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Kalkaji, New Delhi",
        address: "Shop 1/2, Krishna Market, Kalkaji, New Delhi",
        localityUrl: "ncr/kalkaji-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/bakery/",
          name: "Bakery"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "18 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/bakingo-kalkaji-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/bakingo-kalkaji-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.9 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"20377540","element_type":"listing","rank":7}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "3600+ orders placed from here recently"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 18869459,
      name: "RollsKing",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/300988/f9584388125be2b088f1631054735654_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/8/300988/f9584388125be2b088f1631054735654_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "10K",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.9",
            reviewCount: "257",
            reviewTextSmall: "257 Reviews",
            subtext: "257 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.9",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.9",
            reviewCount: "9,781",
            reviewTextSmall: "9,781 Reviews",
            subtext: "9,781 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.9",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Kalkaji, New Delhi",
        address: "Shop-47, First Floor, LS Site 37 And 38, Kalkaji, New Delhi",
        localityUrl: "ncr/kalkaji-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/rolls/",
          name: "Rolls"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "33 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/rollsking-kalkaji-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/rollsking-kalkaji-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18869459","element_type":"listing","rank":8}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "4550+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 19483812,
      name: "WOW! Momo",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/18082196/b46307a6a28d24ecf69d5ec83ee9d451_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/18082196/b46307a6a28d24ecf69d5ec83ee9d451_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.9",
        rating_text: "3.9",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "1,746",
        subtext: "REVIEW",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.8",
            reviewCount: "36",
            reviewTextSmall: "36 Reviews",
            subtext: "36 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.8",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.0",
            reviewCount: "1,710",
            reviewTextSmall: "1,710 Reviews",
            subtext: "1,710 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.0",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Epicuria Food Mall, Nehru Place, New Delhi",
        address:
          "Unit FC-4, Epicuria Food Court, Near Nehru Place Metro Station, Nehru Place, New Delhi",
        localityUrl: "ncr/restaurants/in/epicuria-mall-nehru-place"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTA1MVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/momos/",
          name: "Momos"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "28 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/wow-momo-nehru-place-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/wow-momo-nehru-place-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "723 m",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19483812","element_type":"listing","rank":9}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "1425+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 19333027,
      name: "Theobroma",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/18384116/dff2fc21071f49024fe9b806ffb9646d_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/6/18384116/dff2fc21071f49024fe9b806ffb9646d_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.1",
        rating_text: "4.1",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "4,532",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "3.8",
            reviewCount: "2",
            reviewTextSmall: "2 Reviews",
            subtext: "2 Dining Reviews",
            color: "#1C1C1C",
            ratingV2: "3.8",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.3",
            reviewCount: "4,530",
            reviewTextSmall: "4,530 Reviews",
            subtext: "4,530 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.3",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "700"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹300 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Community Centre, New Friends Colony, New Delhi",
        address:
          "Shop 75, Ground Floor, Community Centre, D.D.A Market, New Friends Colony, New Delhi",
        localityUrl: "ncr/restaurants/in/community-centre-new-friends-colony"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/bakery/",
          name: "Bakery"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/desserts/",
          name: "Desserts"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "26 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/theobroma-new-friends-colony-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/theobroma-new-friends-colony-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "1.7 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19333027","element_type":"listing","rank":10}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF up to 100",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "4925+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 19253042,
      name: "Veer Ji Malai Chaap Wale",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/2/18901212/3be38d2e4f70d288ef36e9e0f0577616_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/2/18901212/3be38d2e4f70d288ef36e9e0f0577616_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "3.8",
        rating_text: "3.8",
        rating_subtitle: "Good",
        rating_color: "9ACD32",
        votes: "3,241",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "3.8",
            reviewCount: "3,241",
            reviewTextSmall: "3,241 Reviews",
            subtext: "3,241 Delivery Reviews",
            color: "#E23744",
            ratingV2: "3.8",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹400 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Defence Colony, New Delhi",
        address: "Shop 108, Flyover Market, Defence Colony, New Delhi",
        localityUrl: "ncr/defence-colony-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/north-indian/",
          name: "North Indian"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAyM1wiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/rolls/",
          name: "Rolls"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "33 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/veer-ji-malai-chaap-wale-defence-colony-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/veer-ji-malai-chaap-wale-defence-colony-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "2.5 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19253042","element_type":"listing","rank":11}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "20% OFF",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "2500+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  },
  {
    type: "restaurant",
    info: {
      resId: 19631395,
      name: "Wendy's Burgers",
      image: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/3/312423/7a8d7e619b4825883795f8f873a99aa7_o2_featured_v2.jpg"
      },
      o2FeaturedImage: {
        url:
          "https://b.zmtcdn.com/data/pictures/chains/3/312423/7a8d7e619b4825883795f8f873a99aa7_o2_featured_v2.jpg"
      },
      rating: {
        has_fake_reviews: 0,
        aggregate_rating: "4.0",
        rating_text: "4.0",
        rating_subtitle: "Very Good",
        rating_color: "5BA829",
        votes: "2,015",
        subtext: "REVIEWS",
        is_new: false
      },
      ratingNew: {
        newlyOpenedObj: null,
        suspiciousReviewObj: null,
        ratings: {
          DINING: {
            rating_type: "DINING",
            rating: "",
            reviewCount: "0",
            reviewTextSmall: "0 Reviews",
            subtext: "Does not offer Dining",
            color: "",
            ratingV2: "-",
            subtitle: "DINING",
            sideSubTitle: "Dining Reviews",
            bgColorV2: {
              type: "grey",
              tint: "500"
            }
          },
          DELIVERY: {
            rating_type: "DELIVERY",
            rating: "4.0",
            reviewCount: "2,015",
            reviewTextSmall: "2,015 Reviews",
            subtext: "2,015 Delivery Reviews",
            color: "#E23744",
            ratingV2: "4.0",
            subtitle: "DELIVERY",
            sideSubTitle: "Delivery Reviews",
            bgColorV2: {
              type: "green",
              tint: "600"
            },
            newOnDelivery: false
          }
        }
      },
      cft: {
        text: "₹350 for two"
      },
      cfo: {
        text: "₹250 for one"
      },
      locality: {
        name: "Defence Colony, New Delhi",
        address:
          "Plot 59 B, 2nd Floor, Kotla Mubarak Pur, Defence Colony, New Delhi",
        localityUrl: "ncr/defence-colony-delhi-restaurants"
      },
      timing: {
        text: "",
        color: ""
      },
      cuisine: [
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTY4XCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/burger/",
          name: "Burger"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
          url: "https://www.zomato.com/ncr/restaurants/fast-food/",
          name: "Fast Food"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
          url: "https://www.zomato.com/ncr/restaurants/american/",
          name: "American"
        },
        {
          deeplink:
            "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
          url: "https://www.zomato.com/ncr/restaurants/beverages/",
          name: "Beverages"
        }
      ],
      should_ban_ugc: false,
      costText: {
        text: "₹250 for one"
      }
    },
    order: {
      deliveryTime: "30 min",
      isServiceable: true,
      hasOnlineOrdering: true,
      actionInfo: {
        text: "Order Now",
        clickUrl: "/ncr/wendys-burgers-defence-colony-new-delhi/order"
      }
    },
    gold: [],
    takeaway: [],
    cardAction: {
      text: "",
      clickUrl: "/ncr/wendys-burgers-defence-colony-new-delhi/order",
      clickActionDeeplink: ""
    },
    distance: "2.8 km",
    isPromoted: false,
    promotedText: "",
    trackingData: [
      {
        table_name: "zsearch_events_log",
        payload:
          '{"search_id":"83a568a3-8ea4-4cd2-84b6-9fd61112a22f","location_type":"delivery_cell","location_id":"4110910938222166016","page_type":"delivery","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19631395","element_type":"listing","rank":12}',
        event_names: {
          tap: '{"action":"tap"}',
          impression: '{"action":"impression"}'
        }
      }
    ],
    allCTA: [],
    promoOffer: "",
    checkBulkOffers: true,
    bulkOffers: [
      {
        text: "50% OFF",
        color: {
          tint: "500",
          type: "blue"
        }
      }
    ],
    isDisabled: false,
    bottomContainers: [
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/4bf016f32f05d26242cea342f30d47a31595763089.png"
        },
        text: "3425+ orders placed from here recently"
      },
      {
        image: {
          url:
            "https://b.zmtcdn.com/data/o2_assets/0b07ef18234c6fdf9365ad1c274ae0631612687510.png",
          aspect_ratio: 2.66666666667
        },
        text: "Follows all Max Safety measures to ensure your food is safe"
      }
    ]
  }
];
